var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":15,"width":2,"indeterminate":"","color":"#19aa8d"}})}
var staticRenderFns = []

export { render, staticRenderFns }